import {
  appConfigProviderKey,
  defaultFormatter,
  formatterProviderKey,
  linksProviderKey,
} from '@metapic-apps/shared'
import type { App } from 'vue'

import { formatMoneyForAdmin } from '@/lib/formatters/money.formatter'
import { config } from '@/lib/helpers/config.helpers'

export const initializeProviders = (app: App) => {
  app.provide(appConfigProviderKey, {
    mediaBaseUrl: config.mediaBaseUrl,
  })

  app.provide(formatterProviderKey, {
    ...defaultFormatter,
    formatMoney: formatMoneyForAdmin,
    getCurrencyLabel: (currency) => currency,
  })

  app.provide(linksProviderKey, {
    getCreatorLink: (creatorId) => `${config.legacyAdminAppUrl}/#/creators/${creatorId}`,
    getAdvertiserLink: (advertiserId) => `/advertisers/${advertiserId}`,
    getCampaignLink: (campaignId) => `/campaigns?campaignId=${campaignId}`,
  })
}
